import { useNavigate } from "react-router-dom";
import getFormatedDate from "../../../utils/helperFunctions/formatedDate";
import sizeCalculator from "../../../utils/helperFunctions/sizeLabelCompiler";
import sanitizeHtml from "../../../utils/UI/sanitizeHtml";
import { useEffect, useState } from "react";

export interface CardProps {
  image_url: string;
  title: string;
  source: string;
  date: string;
  publication: string;
  pubDate: string;
  sourceName: string;
  source_icon?: string;

}

export interface NewsCardProps {
  publisher?: string;
  title?: string;
  img?: string;
  date?: string;
  sentiment?: string;
  traffic?: number;
  description?: string;
  sourceIcon?: string;
  ave?: number;
  keywords?: Array<string>;
  country?: Array<string>;
  language?: string;
  mediaType: string;
  size?: object;
  length?: number;
  link?: string;
}

const Card: React.FC<NewsCardProps> = ({
  publisher,
  title,
  img,
  date,
  sentiment,
  traffic,
  description,
  sourceIcon,
  ave,
  keywords,
  country,
  language,
  mediaType,
  length = 0,
  link,
}) => {
  const navigate = useNavigate();
  const [textDescription, setTextDescription] = useState("");

  const navigateWithData = (dataToSend: NewsCardProps) => {
    navigate("/dashboard/content/article-insight", { state: dataToSend });
  };
  useEffect(() => {
    if (!description) return;
    const text = sanitizeHtml(description || "");
    setTextDescription(text);
  }, [description]);
  
  return (
    <div
      className="card flex flex-col gap-3 cursor-pointer"
      onClick={() =>
        navigateWithData({
          publisher,
          title,
          img,
          date,
          sentiment,
          traffic,
          description: textDescription,
          sourceIcon,
          ave,
          keywords,
          country,
          language,
          mediaType,
          size: sizeCalculator(mediaType, textDescription, length),
          link
        })
      }
    >
      <div className="w-full min-h-[155px] bg-black mt-4 flex justify-center items-center">
        <img src={img} className="w-full max-h-[155px] object-cover" alt="Article image"/>
      </div>
      <div className="card-content flex flex-col gap-3 text-poppins">
        <span className="text-sm font-semibold text-[#334D6E]">
          {title && title.length > 38 ? title?.slice(0, 42) + "..." : title}
        </span>
        <span className="flex flex-col items-start gap-1">
          <span className="text-sm font-semibold text-[#AC14F3]">
            {publisher}
          </span>{" "}
          {/* <span className=" text-sm font-semibold"> | </span> */}
          <span className=" text-sm font-light ">
            {" "}
            {date && getFormatedDate(date)}
          </span>
        </span>
      </div>
    </div>
  );
};

export default Card;
